import { createSelector } from 'reselect'

import API from '../../api/api'

export const SET_TRAINERS = 'SET_TRAINERS'
export const CREATE_TRAINER = 'CREATE_TRAINER'
export const UPDATE_TRAINER = 'UPDATE_TRAINER'

const initialState = {
  trainers: [],
}

const organisationStaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRAINERS:
      return {
        ...state,
        trainers: action.trainers,
      }
    case CREATE_TRAINER: {
      return {
        ...state,
        trainers: [action.data, ...state.trainers],
      }
    }
    case UPDATE_TRAINER: {
      return {
        ...state,
        trainers: state.trainers.map((trainer) => {
          if (trainer.id === action.data.id) {
            return { ...trainer, ...action.data }
          } else {
            return trainer
          }
        }),
      }
    }
    default:
      return state
  }
}

export const fetchTrainers = () => {
  return (dispatch) => {
    return API.getAllTrainers()
      .then((res) => {
        if (res.length !== 0) {
          dispatch(setTrainers(res))
        }
        return Promise.resolve(res)
      })
      .catch((err) => Promise.reject(err))
  }
}

export const createTrainer = (data) => {
  return (dispatch) => {
    return API.createNewManagementUser(data, 'trainer')
      .then((res) => {
        dispatch({ type: CREATE_TRAINER, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const updateTrainer = (data, id) => {
  return (dispatch) => {
    return API.updateTrainerData(data, id)
      .then((res) => {
        dispatch({ type: UPDATE_TRAINER, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const setTrainers = (trainers) => {
  return {
    type: SET_TRAINERS,
    trainers,
  }
}

export const selectTrainers = (state) => state.organisationStaff.trainers

export const selectActiveServices = (services) =>
  services && services.filter((service) => service.serviceId && service.serviceId.active)

export const selectTrainerById = createSelector(
  selectTrainers,
  (_, id) => id,
  (trainers, id) => {
    if (id === 'new') {
      return {
        user: {},
      }
    }
    return trainers.find((trainer) => trainer.id === parseInt(id)) || trainers[0] || { user: {} }
  },
)

export default organisationStaffReducer
